// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.neonwallet",
    name: "Neon Wallet",
    homepage: "https://neonwallet.com",
    image_id: "322bd6f0-09b5-4595-cb15-0dfab8054800",
    app: {
        browser: "https://neonwallet.com/",
        ios: "https://apps.apple.com/my/app/neon-wallet-mobile/id1530111452",
        android: "https://play.google.com/store/apps/details?id=neo.org.freewallet.app&hl=pt_BR&gl=US",
        mac: "https://neonwallet.com/",
        windows: "https://neonwallet.com/",
        linux: "https://neonwallet.com/",
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "neon://uri=",
        universal: null,
    },
    desktop: {
        native: "neon://uri=",
        universal: null,
    },
};
//# sourceMappingURL=index.js.map